// extracted by mini-css-extract-plugin
export default {"control":"control_control__ik2jT","pdUpload":"control_pdUpload__ZbY2h","previewInput":"control_previewInput__floz-"};